import { createContainer } from 'react-sweet-state';

import { ACTIONS, ImageStyleStore } from './ImageStyleStore';

export const ImageStyleStoreContainer = createContainer(ImageStyleStore, {
  onInit:
    () =>
    ({ setState, dispatch }, { state }) => {
      dispatch(ACTIONS.init());

      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState, dispatch }, { state }) => {
      dispatch(ACTIONS.update());

      if (state) {
        setState(state);
      }
    },
});
